import { cloneDeep } from 'lodash'

export default (newRangesOfPerformance, currentRangesOfPerformance) => {
    newRangesOfPerformance = cloneDeep(newRangesOfPerformance)
    currentRangesOfPerformance = cloneDeep(currentRangesOfPerformance)
    return currentRangesOfPerformance.map(c => {
        const n = newRangesOfPerformance.find(n => n.id === c.id)
        return { ...c, ...n }
    })
}
